import { Component, Input } from '@angular/core';
import { Process } from 'src/app/core/models/process.model';

@Component({
  selector: 'app-process-collection-documents',
  standalone: true,
  imports: [],
  templateUrl: './process-collection-documents.component.html',
  styles: ``
})
export class ProcessCollectionDocumentsComponent {
  @Input() process!: Process;
}
